import { render, staticRenderFns } from "./Mark-FixIncomeList.vue?vue&type=template&id=5206e613&scoped=true&"
import script from "./Mark-FixIncomeList.vue?vue&type=script&lang=js&"
export * from "./Mark-FixIncomeList.vue?vue&type=script&lang=js&"
import style0 from "./Mark-FixIncomeList.vue?vue&type=style&index=0&id=5206e613&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206e613",
  null
  
)

export default component.exports